import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/ai/AiExample/list", {
        params: {
            ...params
        }
    } )
}

function GET_SEACH(params) {
    return axios.get("/ai/AiExample/selects", {
        params: {
            ...params
        }
    } )
}


function EDIT_DATA(params) {
    return  axios.post("/ai/AiExample/info",
      {id:params}
      )
}

function SUBMIT_EDIT(params) {
    return  axios.post("/ai/AiExample/updated",{...params} )
}

function SUBMIT_ADD(params) {
    return  axios.post("/ai/AiExample/created",{...params} )
}
function LIST_ORDER(params) {
    return  axios.post("/ai/AiExample/listOrder",{list_orders:params} )
}
function DELE(params) {
    return axios.get("/ai/AiExample/deleted", {
        params: {
            id: params
        }
    })
}

export default {
    GET_LIST,
    EDIT_DATA,
    SUBMIT_EDIT,
    GET_SEACH,LIST_ORDER,SUBMIT_ADD,DELE
}